module.exports = __webpack_public_path__ + "assets/ParallelDetailed.231972becaf1bd7b126919497962a12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ParallelDetailed.png
// module id = 544
// module chunks = 0